import jaJPKeys from './locales/ja-JP.json';
import enUSKeys from './locales/en-US.json';

import { LocaleCode } from '../constants/localization';

// eslint-disable-next-line import/group-exports
export const localeSources: Record<LocaleCode, any> = {
    [LocaleCode.ja_JP]: jaJPKeys,
    [LocaleCode.en_US]: enUSKeys,
};

// eslint-disable-next-line import/group-exports
export const loadLocaleBundle = (localeCode: LocaleCode): any => {
    const localeSrc =
        localeSources[localeCode] ||
        localeSources[localeCode.slice(0, 2) as LocaleCode] ||
        localeSources[LocaleCode.en_US];

    return Promise.resolve(localeSrc);
};
